import styled from "styled-components";

export const LicenseStatus = styled.div`
  overflow: auto;
  max-height: 75vh;
`;
